// @ts-nocheck
import React, { useContext } from 'react'
import {Link, useLocation} from 'react-router'
import Styles from './Navbar.module.css'
import Logo from '../../assets/logo.svg?react'
import { useAuth } from '../../context/AuthContext'
import useTargetingPermissions from '../../pages/TargetingV2/hooks/useTargetingPermissions'
import { ExercisesContext } from '../../ExercisesContext'
import Icon from '../Icon/Icon'
import { useFeatureFlags } from '../../hooks/useFeatureFlags'

export default function Navbar(props) {
    const { user, signOut, isAuthenticated } = useAuth()
    const { isAdminUser, isMultiExerciseUser, isElevatedViewer } = useTargetingPermissions()
    const { ExhibitsDisplaysBroadAccess, OrganizationsDermTeamsAccess } = useFeatureFlags()
    const exercises = useContext(ExercisesContext)
    const location = useLocation()
    let cog = ''
    let themeToggle = ''
    let xus = ''
    let hcp = ''
    let hco = ''
    let targeting = []
    let workflow = ''

    if (isAuthenticated && user) {
        if (user.role === 'ADMIN') {
            cog = (
                <Link to='/admin' onClick={() => { if (location.pathname === '/admin') window.location.reload(); }}>
                    <div className={[Styles.navRightItem, location.pathname === '/admin' ? Styles.navRightActive : ''].join(' ')}>
                        <Icon name="sliders" aria-hidden={true} />
                    </div>
                </Link>
            )
        } else {
            cog = user.IsImpersonated
                ? <div className={Styles.navRightItem}><span aria-label="Impersonating">🎭</span></div>
                : ''
        }

        if (true) {
            themeToggle = (
                <button
                    className={Styles.themeToggle}
                    onClick={props.toggleDarkMode}
                    title={props.darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
                >
                    {props.darkMode
                        ? (<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <circle cx="12" cy="12" r="5"/>
                            <line x1="12" y1="1" x2="12" y2="3"/>
                            <line x1="12" y1="21" x2="12" y2="23"/>
                            <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
                            <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
                            <line x1="1" y1="12" x2="3" y2="12"/>
                            <line x1="21" y1="12" x2="23" y2="12"/>
                            <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
                            <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
                          </svg>)
                        : (<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79Z"/>
                          </svg>)
                    }
                </button>
            )
        }

        if ((user.role === 'ADMIN' || user.role === 'COMPLIANCE' || user.role !== 'ExUS') && ["81","82"].includes(user.team) == false) {
            hcp = (
                <Link to='/hcp'>
                    <li key={2} className={location.pathname === '/hcp' || location.pathname.includes('/hcp/details') ? Styles.Active : ''}
                        onClick={() => { if (location.pathname === '/hcp') window.location.reload(); }}>
                        <div className={Styles.Pages}>Professionals</div>
                    </li>
                </Link>
            )
        }
        // Always visible to Admins/Compliance. Hidden from DERM teams by default —
        // gated behind OrganizationsDermTeamsAccess (default off); flip it in
        // FeatureManagement config to reopen the tab to those teams without a
        // code change.
        var organizationsDermTeams = ['31', '33', '34', '35', '53', '81', '82'];
        var hasOrganizationsTeamAccess = OrganizationsDermTeamsAccess || !organizationsDermTeams.includes(user.team);
        if (user.role === 'ADMIN' || user.role === 'COMPLIANCE' || user.role !== 'ExUS' && hasOrganizationsTeamAccess) {
            hco = (
                <Link to='/hco'>
                    <li key={3} className={location.pathname === '/hco' || location.pathname.includes('/hco/details') ? Styles.Active : ''}
                        onClick={() => { if (location.pathname === '/hco') window.location.reload(); }}>
                        <div className={Styles.Pages}>Organizations</div>
                    </li>
                </Link>
            )
        }
        if (user.role === 'ADMIN' || user.role === 'ExUS' || user.isExUsUser === 'true' || ["81", "82"].includes(user.team)) {
            xus = (
                <Link to='/exus'>
                    <li key={4} className={location.pathname === '/exus' || location.pathname.includes('/exus/details') ? Styles.Active : ''}
                        onClick={() => { if (location.pathname === '/exus') window.location.reload(); }}>
                        <div className={Styles.Pages}>Ex-US Professionals</div>
                    </li>
                </Link>
            )
        }

        if (exercises && exercises.targeting?.length > 0) {
            const useDropdown = exercises.targeting.length > 1;

            if (useDropdown) {
                const basePath = isAdminUser ? '/targeting/admin' : '/targeting';
                const anyActive = exercises.targeting.some(e =>
                    location.pathname.includes(`${basePath}/${e.ID}`)
                );
                targeting = (
                    <li className={[Styles.targetingDropdown, anyActive ? Styles.Active : ''].join(' ')}>
                        <div className={Styles.Pages}>
                            <Icon name="bullseye" />&nbsp;Targeting&nbsp;
                            <Icon name="chevron-down" style={{fontSize:'9px', marginLeft:'4px'}} />
                        </div>
                        <div className={Styles.dropdownMenu}>
                            {exercises.targeting.map(exercise => {
                                const path = `${basePath}/${exercise.ID}`;
                                const isActive = location.pathname.includes(path);
                                return (
                                    <Link key={exercise.ID} to={path}>
                                        <div
                                            className={[Styles.dropdownItem, isActive ? Styles.dropdownItemActive : ''].join(' ')}
                                            onClick={() => { if (location.pathname.includes(path)) window.location.reload(); }}
                                        >
                                            <Icon name="bullseye" style={{marginRight:'8px', fontSize:'11px', opacity:0.7}} />
                                            {exercise.NAME}
                                        </div>
                                    </Link>
                                );
                            })}
                        </div>
                    </li>
                );
            } else if (isAdminUser) {
                targeting = (
                    <Link key={exercises.targeting[0].ID} to={`/targeting/admin/${exercises.targeting[0].ID}`}>
                        <li className={location.pathname.includes(`/targeting/admin/${exercises.targeting[0].ID}`) ? Styles.Active : ''}
                            onClick={() => { if (location.pathname.includes(`/targeting/admin/${exercises.targeting[0].ID}`)) window.location.reload(); }}>
                            <div className={Styles.Pages}><Icon name="bullseye" />&nbsp;{exercises.targeting[0].NAME}</div>
                        </li>
                    </Link>
                );
            } else {
                // Elevated viewers (OBD etc) land on the admin summary panel; plain reps go directly to their exercise
                const singleTargetPath = isElevatedViewer ? '/targeting' : `/targeting/${exercises.targeting[0].ID}`;
                targeting = (
                    <Link to={singleTargetPath}>
                        <li className={location.pathname.includes('/targeting') ? Styles.Active : ''}
                            onClick={() => { if (location.pathname.includes('/targeting')) window.location.reload(); }}>
                            <div className={Styles.Pages}><Icon name="bullseye" />&nbsp;{exercises.targeting[0].NAME}</div>
                        </li>
                    </Link>
                );
            }
        }

        // Always visible to Admins and E&D Admins. The broader role list below is
        // gated behind the ExhibitsDisplaysBroadAccess flag (default off) — flip it
        // in FeatureManagement config to reopen the tab to those roles without a
        // code change.
        var workflowEnabledForRoles = ['OCNE', 'ADMIN', 'OHS', 'OBD', 'DTS', 'DBD', 'ITS', 'IDD', 'ASD', 'ABD', 'VP'];
        var hasExhibitsDisplaysAdminAccess = user.role === 'ADMIN' || user.IsEDAdmin == "true";
        var hasExhibitsDisplaysBroadAccess = ExhibitsDisplaysBroadAccess && (
               workflowEnabledForRoles.includes(user.role) ||
               user.IsHemoncComp == "true" || user.IsDermComp == "true" ||
               user.IsDermOps == "true"   || user.IsHemoncOps == "true" ||
               user.IsMarketAccessRole == "true");
        if ((hasExhibitsDisplaysAdminAccess || hasExhibitsDisplaysBroadAccess) &&
            ["81", "82"].includes(user.team) == false) {
            workflow = (
                <Link to='/workflow'>
                    <li key={5} onClick={() => { if (location.pathname === '/workflow') window.location.reload(); }}>
                        <div className={Styles.Pages}>Exhibits &amp; Displays</div>
                    </li>
                </Link>
            )
        } else {
            workflow = '';
        }
    }

    return (
        !isAuthenticated && !user ? <div></div> :
        <div className={Styles.NavBar}>

            {/* ── Left: logo + nav links ──────────────────────────────── */}
            <div className={Styles.navLeft}>
                <div className={Styles.Wrapper}>
                    <Logo className={Styles.Logo} aria-label="Incyte MDM Portal" />
                </div>
                <ul className={Styles.navLinks}>
                    <Link to='/'>
                        <li key={1} className={location.pathname === '/' ? Styles.Active : ''}
                            onClick={() => { if (location.pathname === '/') window.location.reload(); }}>
                            <div className={Styles.Pages}>Home</div>
                        </li>
                    </Link>
                    {hcp}
                    {hco}
                    {xus}
                    {targeting}
                    {workflow}
                </ul>
            </div>

            {/* ── Right: user chrome — never clips ────────────────────── */}
            <div className={Styles.navRight}>
                <span className={Styles.username}>{user.userName}</span>
                {cog}
                {themeToggle}
                <span className={Styles.logoutBtn}
                    onClick={() => signOut()}
                >Logout</span>
            </div>

        </div>
    )
}
